import { Navigate, useSearchParams } from 'react-router';

import { paths } from 'src/routes/paths';

// ----------------------------------------------------------------------
// `/dashboard/debug/explore` used to be one screen; it is now three. Links
// that carried `?viewer=` were asking for the deck explanation, the rest
// for the map. The query string travels along so deep links keep working.
// ----------------------------------------------------------------------

export function ExploreIndexRedirect() {
  const [searchParams] = useSearchParams();
  const search = searchParams.toString();
  const pathname = searchParams.get('viewer')
    ? paths.dashboard.debug.explore.deck
    : paths.dashboard.debug.explore.map;
  return <Navigate replace to={{ pathname, search: search ? `?${search}` : '' }} />;
}
